import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Footer from "../components/footer";
import Navigation from "../components/navigation";
require("../styles/main.scss");
var Layout = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(Layout, _React$Component);
    function Layout() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Layout.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("section", {
            className: this.props.className || "content",
            role: "main"
        }, /*#__PURE__*/ React.createElement(Navigation, null), this.props.children, /*#__PURE__*/ React.createElement(Footer, null));
    };
    return Layout;
}(React.Component);
export { Layout as default };
